'use client'

import { useMutation } from '@tanstack/react-query'
import { Fingerprint } from 'lucide-react'

import { Message } from '~/components/component-library'
import { useAddNewPasskey } from '~/hooks/useAddNewPasskey'
import { sendTrackingData } from '~/utils/tracking'

// Invited members land on the dashboard with no passkey and nothing telling
// them they can't sign or be added as a signer until they add one. The parent
// decides whether to render it so an empty header slot adds no spacing.
export const PasskeySetupMessage = () => {
  const { addNewPasskey } = useAddNewPasskey()

  const { mutate: addPasskey, isPending } = useMutation({
    mutationFn: addNewPasskey,
  })

  return (
    <Message
      variant="warning"
      title="Setup required"
      action={{
        label: 'Add passkey',
        // The spinner swaps in for the prefix icon, so the button keeps its
        // width while loading instead of pushing the text around.
        prefix: <Fingerprint />,
        isLoading: isPending,
        onClick: () => {
          sendTrackingData('clickAddPasskey')
          addPasskey()
        },
      }}
    >
      As an owner or member you need a passkey to sign transactions.
    </Message>
  )
}
